import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {

  email: string = '';
  showSuccessMessage = false;

  images = [
    'assets/collegiatemobile-home/masterhead0.jpg',
    'assets/collegiatemobile-home/masterhead1.jpg',
    'assets/collegiatemobile-home/masterhead2.jpg',
    'assets/collegiatemobile-home/masterhead3.jpg',
    'assets/collegiatemobile-home/masterhead4.jpg',
    'assets/collegiatemobile-home/masterhead5.jpg',
  ];
  currentIndex = 0;

  schools = [
    {
      name: 'Indiana Bible College',
      city: 'Indianapolis, Indiana',
      colors: ['bg-black', 'bg-red-600'],
    },
    {
      name: 'Indiana Institute of Technology',
      city: 'Fort Wayne, Indiana',
      colors: ['bg-black', 'bg-orange-500', 'bg-white'],
    },
    {
      name: 'Indiana State University',
      city: 'Terra Haute, Indiana',
      colors: ['bg-blue-400', 'bg-white'],
    },
    {
      name: 'Indiana University Bloomington',
      city: 'Bloomington, Indiana',
      colors: ['bg-white', 'bg-red-700'],
    },
    {
      name: 'Indiana University Columbus',
      city: 'Columbus, Indiana',
      colors: ['bg-red-100', 'bg-red-700'],
    },
    {
      name: 'Indiana University East',
      city: 'Richmond, Indiana',
      colors: ['bg-red-100', 'bg-red-700'],
    }
  ];

  filteredSchools: any[] = []; // Starts empty

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private settingsService: PageviewsettingsService,
  ) {}

  ngOnInit(): void {
    this.showSuccessMessage = false;
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 5000);
  }

  resetSuccessMessage() {
    this.showSuccessMessage = false;
  }

  callvisitoranalytics() {
    if (!this.email) return;
    this.settingsService.createvisitoranalytics('collegiatemobilelandingpage', this.email)
      .then(response => {
        console.log('Visitor analytics endpoint called successfully', response);
        this.showSuccessMessage = true;
      })
      .catch(error => {
        console.error('Error calling endpoint', error);
        this.showSuccessMessage = false;
      });
  }

  onSearchChange(query: string) {
    this.email = query;
    this.resetSuccessMessage();
    if (!query.trim()) {
      this.filteredSchools = [];
      return;
    }
    this.filteredSchools = this.schools.filter(s =>
      s.name.toLowerCase().includes(query.toLowerCase())
    );
  }
}
